




























import {Component,Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
@Component({
  components:{
  },
  computed:
          mapGetters({
            pageTitle: 'title/pageTitle'
          }),
})
export default class Loggedout extends Vue {
  public step = 0;
}

